import { type AuthUser } from "~/api/auth/AuthUser";
import { useAuth } from "~/hooks/useAuth";
import { type AppPermission, type StaffPermission } from "~/utils/permissions";

type Permission = AppPermission | StaffPermission;

export const useHasPermission = (permission: Permission | null): boolean => {
  const { user } = useAuth();

  return hasPermission(user, permission);
};

export const hasPermission = (user: AuthUser, permission: Permission | null) =>
  !permission ? true : (user?.permissions.includes(permission) ?? false);
